var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H38C43.5229 0 48 4.47715 48 10V38C48 43.5229 43.5228 48 38 48H10C4.47715 48 0 43.5228 0 38V10Z",
    fill: "#05DF72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12.334V35.6673",
    stroke: "#0D542B",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8333 15.834H21.0833C20.0004 15.834 18.9618 16.2642 18.196 17.03C17.4302 17.7957 17 18.8344 17 19.9173C17 21.0003 17.4302 22.0389 18.196 22.8047C18.9618 23.5704 20.0004 24.0007 21.0833 24.0007H26.9167C27.9996 24.0007 29.0382 24.4309 29.804 25.1966C30.5698 25.9624 31 27.001 31 28.084C31 29.167 30.5698 30.2056 29.804 30.9713C29.0382 31.7371 27.9996 32.1673 26.9167 32.1673H17",
    stroke: "#0D542B",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashVector);
export default __webpack_public_path__ + "static/media/CashVector.d0f1189e18631e54ed7a9a9d9ad2c641.svg";
export { ForwardRef as ReactComponent };